import { useEffect, useRef, useState } from "react";
import { Map, View } from "ol";
import TileImage from "ol/source/TileImage";
import TileLayer from "ol/layer/Tile";
import ScaleLine from "ol/control/ScaleLine.js";
import Rotate from "ol/control/Rotate.js";
import { defaults as defaultControls } from "ol/control/defaults.js";
import { fromLonLat } from "ol/proj";

export function useMap(open: boolean) {
	const mapContainerRef = useRef<HTMLElement>();

	const [map, setMap] = useState<Map | null>(null);

	useEffect(() => {
		if (!mapContainerRef.current) return () => {};

		const newMap = new Map({
			target: mapContainerRef.current,
			controls: defaultControls().extend([
				new ScaleLine({
					units: "us",
				}),
				new Rotate({
					autoHide: false,
				}),
			]),
			layers: [
				new TileLayer({
					source: new TileImage({
						url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
					}),
				}),
				new TileLayer({
					source: new TileImage({
						url: "https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}",
					}),
				}),
				new TileLayer({
					source: new TileImage({
						url: "https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
					}),
				}),
			],
			view: new View({
				center: fromLonLat([-89.400522, 40.633125]),
				zoom: 8,
				maxZoom: 19,
			}),
		});

		setMap(newMap);

		return () => {
			setMap(null);
			newMap.setTarget(undefined);
		};
	}, [open]);

	return { map, mapContainerRef };
}